export const ROAM_SCENE = 'roam_scene'
export const CHANGE_SCENE = 'change_scene'
export const SHOW_EDITOR_BOX = 'show_editor_box'
export const SELECTED_HOTSPOT = 'selected_hotspot'

export const TOOLBAR_SCENE = 'tools_scene'
export const TOOLBAR_VR = 'tools_vr'
export const TOOLBAR_SAY = 'tools_say'
export const TOOLBAR_SHARE = 'tools_share'
export const TOOLBAR_VOICE = 'tools_voice'
export const TOOLBAR_FULL = 'tools_full'
export const NEXT_VIDEO = 'next_video'

export const STORAGE_USERINFO = 'userinfo'
export const STORAGE_ZAN = 'praise'

export const OPEN_IFRAME = 'OPEN_IFRAME'
export const OPEN_ARTICLE = 'OPEN_ARTICLE'
